module.exports = __webpack_public_path__ + "img/female-factory.fb352fd.jpeg";